class Test {
    static isString(value) {
        return typeof value === 'string' || value instanceof String;
    }

    static isNumber(value) {
        return typeof value === 'number' && isFinite(value);
    }

    static isArray(value) {
        return Array.isArray(value);
    }

    static isFunction(value) {
        return typeof value === 'function';
    }

    static isObject(value) {
        return value && typeof value === 'object' && value.constructor === Object;
    }

    static isNull(value) {
        return value === null;
    }

    static isUndefined(value) {
        return typeof value === 'undefined';
    }

    static isBoolean(value) {
        return typeof value === 'boolean';
    }

    static isRegExp(value) {
        return value && typeof value === 'object' && value.constructor === RegExp;
    }

    static isError(value) {
        return value instanceof Error && typeof value.message !== 'undefined';
    }

    static isDate(value) {
        return value instanceof Date;
    }

    static isSymbol(value) {
        return typeof value === 'symbol';
    }

    static isEqual(value, other) {
        // Get the value type
        const type = Object.prototype.toString.call(value);

        // If the two objects are not the same type, return false
        if(type !== Object.prototype.toString.call(other)) {
            return false;
        }

        // If items are not an object or array, return false
        if(['[object Array]', '[object Object]'].indexOf(type) < 0) {
            return false;
        }

        // Compare the length of the length of the two items
        const valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
        const otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
        if(valueLen !== otherLen) {
            return false;
        }

        // Compare two items
        const compare = (item1, item2) => {

            // Get the object type
            const itemType = Object.prototype.toString.call(item1);

            // If an object or array, compare recursively
            if(['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
                if(! Test.isEqual(item1, item2)) {
                    return false;
                }
            }
            // Otherwise, do a simple comparison
            else {
                // If the two items are not the same type, return false
                if(itemType !== Object.prototype.toString.call(item2)) {
                    return false;
                }

                // Else if it's a function, convert to a string and compare
                // Otherwise, just compare
                if(itemType === '[object Function]') {
                    if(item1.toString() !== item2.toString()) {
                        return false;
                    }
                }
                else {
                    if(item1 !== item2) {
                        return false;
                    }
                }
            }
        };

        // Compare properties
        if(type === '[object Array]') {
            for(let i = 0; i < valueLen; i++) {
                if(compare(value[i], other[i]) === false) {
                    return false;
                }
            }
        }
        else {
            for(const key in value) {
                if(value.hasOwnProperty(key)) {
                    if(compare(value[key], other[key]) === false) {
                        return false;
                    }
                }
            }
        }

        // If nothing failed, return true
        return true;
    }

}

export default Test;
